import { css } from 'styled-components';

import { styleAttribute } from '@fil-react-mixins/styled';

export default css`
  ${({ flexDirection }: any) => flexDirection && styleAttribute('flex-direction', flexDirection)}
  ${({ flexWrap }: any) => flexWrap && styleAttribute('flex-wrap', flexWrap)}
  ${({ justifyContent }: any) =>
    justifyContent && styleAttribute('justify-content', justifyContent)}
  ${({ alignItems }: any) => alignItems && styleAttribute('align-items', alignItems)}
  ${({ alignContent }: any) => alignContent && styleAttribute('align-content', alignContent)}
  ${({ order }: any) => order && styleAttribute('order', order, false)}
  ${({ flexGrow }: any) => flexGrow && styleAttribute('flex-grow', flexGrow, false)}
  ${({ flexShrink }: any) => flexShrink && styleAttribute('flex-shrink', flexShrink, false)}
  ${({ alignSelf }: any) => alignSelf && styleAttribute('align-self', alignSelf)}
`;
